export const CYCLE_OPTIONS = [
  { key: "Weekly", value: 1 },
  { key: "Every two weeks", value: 2 },
  { key: "Every four weeks", value: 4 },
];
